'use strict';

frontendApp.controller('TrialWarningCtrl', ['$scope', '$uibModal', function($scope, $uibModal) {

    $scope.OpenCreditCardDialog = function(project) {
        $uibModal.open({
            backdrop: true,
            keyboard: true,
            backdropClick: true,
            templateUrl:  'partials/dialog_credit_card.html',
            controller: 'CreditCardModalController',
            scope: $scope,
            resolve: {
                project: function() { return project },
                message: function() { return "" }
            }
        });
    };

}]);

